import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class MyProfileService extends RestfulService<Models.MyProfile> {

  constructor(private restService: RestService) {
    super(Models.MyProfile);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('my-profiles');
  }

}
